import styled from "styled-components";

export const ButtonComponent = styled.button`
  background: linear-gradient(to right, #b224ef, #7579ff, #7579ff);

  border-radius: 16px;

  background: linear-gradient(to right, #b224ef, #7579ff, #7579ff);
  border: none;

  font-size: 24px;

  @media (max-width: 780px) {
    font-size: 16px;
  }
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
`;
